// removed by extract-text-webpack-plugin
module.exports = {"backgroundColor":"#f7f7f9","preview":"bNHTvV7HeBKe_k3wAutwq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ShowCase/Preview/Preview.css
// module id = 858
// module chunks = 0